import { render, staticRenderFns } from "./payByOthers.vue?vue&type=template&id=585c0868"
import script from "./payByOthers.vue?vue&type=script&lang=js"
export * from "./payByOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports